module.exports = __webpack_public_path__ + "41e9ff90477413d9091701584fe41c5f.svg";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-regular-webfont.svg
// module id = 435
// module chunks = 0